
























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { JobListModule } from '@/store/modules/jobList';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';


@Component({
    name: 'JobListSearchCriteria'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public locationSearch: any = null;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      await JobListModule.getCompaniesForSearchOptions();
      await JobListModule.getLocationsForSearchOptions();
      await JobListModule.getWorkersForSearchOptions();
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.skills.length === 0) {
        await AgencySettingsModule.getSkills();
      }
      if (AgencySettingsModule.qualifications.length === 0) {
        await AgencySettingsModule.getQualifications();
      }
    }
  }

  @Watch('searchOptionsVM.selectedWorker')
  async onSelectedWorkerChanged(val: WorkerProfileDto, oldVal: WorkerProfileDto) {
   if (val) {
      await JobListModule.getWorkerPositions(val.id);
      if (val.desiredAnnualSalary !== 0) {
        this.searchOptionsVM.annualSalary = val.desiredAnnualSalary;
      }
      else {
      this.searchOptionsVM.annualSalary = null;
      }
    } else {
      //Clear the positions and salary
      JobListModule.jobSearchViewModel.selectedPositions = [];
      this.searchOptionsVM.annualSalary = null;
    }
  }

  get searchOptionsVM() {
      return JobListModule.jobSearchViewModel;
  }

  get statusOptions() {
    return ListUtils.jobStatuses();
  }
  
  get positions() {
    return AgencySettingsModule.positions;
  }

  get skills() {
    return AgencySettingsModule.skills;
  }

  get qualifications() {
    return AgencySettingsModule.qualifications;
  }

  get jobTypeOptions() {
    return ListUtils.jobTypes();
  }

  get distanceOptions() {
    return ListUtils.distanceOptions();
  }

  get loading() {
    return JobListModule.loading;
  }

  async search() {
    this.dialog = false;
    await JobListModule.searchJobs()
  }
}
